import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import AvailabilitySmall from "./Tour/AvailabilitySmall";
import { tourTileImage } from "../seo/tourSeo";

/** One tour card in the home page grid. */
const Tour = ({ tour }) => {
  const to = `/${tour.pathTitle}`;
  return (
    <Col xl={3} lg={4} md={6} sm={6} xs={6} className="tour-card-col">
      <article className="tour-card">
        <Link to={to} className="tour-card__img-wrap" tabIndex={-1} aria-hidden="true">
          <img
            src={tourTileImage(tour, 300)}
            srcSet={`${tourTileImage(tour, 300)} 300w, ${tourTileImage(tour, 600)} 600w`}
            sizes="(max-width: 575px) 50vw, (max-width: 991px) 33vw, 270px"
            width="300"
            height="420"
            loading="lazy"
            alt=""
          />
          {tour.price && <span className="tour-card__price">From ${tour.price}</span>}
        </Link>

        <div className="tour-card__body">
          <h3 className="tour-card__title">
            <Link to={to} className="tour-card__title-link">{tour.title}</Link>
          </h3>
          <Link to={to} className="tour-card__cta">
            Tour Details<span className="sr-only">: {tour.title}</span>
          </Link>
        </div>

        <div className="tour-card__avail">
          <AvailabilitySmall thundertixId={tour.thundertixId} slug={tour.pathTitle} />
        </div>
      </article>
    </Col>
  );
};

export default Tour;
